import BaseInteractionService from '@configuratorware/configurator-frontendgui/App/Services/InteractionService';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import { SaveTypes } from '@configuratorware/configurator-frontendgui/App/configuration';
import { EventTypes } from '@configuratorware/configurator-frontendgui/App/Constant';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { METHOD_REQUEST_OFFER_FORM_SENT } from '@configuratorware/configurator-frontendgui/App/Utils/createMessageInterface';

class InteractionService extends BaseInteractionService {
  async sendReceiveOfferRequest(formData) {
    if (formData.hasError) {
        return false;
    }

    try {
        Services.ui.show('addToCartPopUpLoader');
        await Services.configurator.captureAndSaveConfiguration(SaveTypes.OFFERREQUEST);
        Services.analytics.triggerEvent(EventTypes.selected_amounts);
    } catch (e) {
        Services.ui.reportError(t('receiveOfferForm.sentError'));

        return false;
    } finally {
        Services.ui.hide('addToCartPopUpLoader');
    }

    const { configuration } = Services.configurator.state;

    const data = {
        configurationCode: configuration.code,
        emailAddress: formData.email,
        name: formData.name,
        company: formData.company,
        phoneNumber: formData.phonenumber,
        street: formData.street,
        zip: formData.zip,
        city: formData.city,
        country: formData.country,
        projectNumber: formData.projectnumber,
        branchNumber: formData.branchnumber
    };

    try {
        await Api.request({ url: 'receiveoffers/request', method: 'post', data: data });
        this.postMessageToContainer({
            method: METHOD_REQUEST_OFFER_FORM_SENT,
            code: configuration.code,
        });
    } catch (error) {
        Services.ui.reportError(t('receiveOfferForm.sentError'));

        return false;
    }

    Services.ui.reportError(t('receiveOfferForm.sentOk'));

    return true;
}
}

export default InteractionService;
